module.exports = {
    CST: {
        DATE_TIME_24: 'DD/MM/YYYY HH:mm:ss',
        DATE_FORMAT: 'DD/MM/YYYY',
        TIME_FORMAT_24: 'HH:mm:ss',
        DATE_FORMAT_YEAR: 'YYYY',
        CBX_ISENABLE: 'Show Enabled Only',
        LINK_CLEAR_FILTER: 'Clear Filter',
        ADD: 'Add ',
        EDIT: 'Edit ',
        DELETE: 'Delete ',
    },
    BROADCAST: {
        HEADER_DELETE_TARGET: 'Delete Broadcast Target',
    },
    MY_SALON: {
        MEMBER: 'Member ',
        CHANGE_MOBILE: 'Change Mobile',
        DELETED_MEMBER: 'Deleted Member',

        CHECKLIST: 'Brand Checklist'
    },
    SALON_MENU: {
        HEADER: 'Salon Menu ',
        HEADER_SUB: 'Sub-Category',
        HEADER_DETAIL: 'Details for '
    },
    SALON_REPORT: {
        SALES: 'Sales ',
        SUMMARY: '(Summary) ',
        LIST: '(List) ',
        OUTSTANDINGS: 'Outstandings ',
        CREDIT: 'Credit ',
        HEADER_ROLLBACK_CREDIT: 'Rollback Transaction',
        Q_ROLLBACK_CREDIT: 'Are you sure you want to rollback this transaction?',
        SUCCESS_ROLLBACK_CREDIT: 'Transaction deleted successfully.',
        POINT: 'Point ',
        VOUCHER: 'Package '
    },
    OUTLET_SETTING: {
        OUTLET: 'Outlet ',
        HEADER_MANAGE_OUTLET: 'Manage Outlet',
        HEADER_MANAGE_ACTION: 'Action for ',
        FORCE_LOGOUT: 'Force Logout',
        HEADER_FORCE_LOGOUT: 'Force Logout Confirmation',
        Q_FORCE_LOGOUT: 'Are you sure you want to logout from ', 
        LOGOUT_SUCCESS: 'Successfully logged out from ',

        BOOKING_BLOCK_LIST: 'Booking (Black List)',
        HEADER_DELETE_BOOKING_BLOCK: 'Delete Booking Black List',
        Q_DELETE_BOOKING_1: 'Are you sure you want to remove "',
        Q_DELETE_BOOKING_2: '" from Booking Black List?',
        BOOKING_BLOCK_ADD_SUCCESS: ' added from black list successfully.',
        BOOKING_BLOCK_REMOVE_SUCCESS: ' removed from black list successfully.',

        STAFF: 'Staff',
        HEADER_DELETE_STAFF: 'Delete Staff'
    },
    REPORT: {
        CSV: '.csv',
        HEADER: 'Tunai Report - ',
        REPORT_GENERATE: 'Report generated on: ',
    },
    ERROR: {
        INVALID_TOKEN: 'Invalid Token',
        SYSTEM_ERROR: 'System Error.',
    },
    SETUP_TITLE: 'Go through the steps below to setup your booking website.',
    Q_DELETE: 'Are you sure you want to delete ',    
    Q_DELETE_IMAGE: 'Are you sure you want to delete this image?',    
    NO_RECORD: 'No record found.',
    NO_RECORD_IMAGE: 'No record found. Drop image to the dropzone below to add new image.',
    ADD_SUCCESS: ' added successfully.',
    UPDATE_SUCCESS: ' updated successfully.',
    DELETE_SUCCESS: ' deleted successfully.',
    IMG_UPLOAD_SUCCESS: 'Image uploaded successfully.',
    IMG_DELETE_SUCCESS: 'Image deleted successfully.',
    IMG_UPLOAD_ERROR: 'Error uploading image',
    INVALID_BASE_PRICE: 'Invalid "Base Price" entered.',
    
    ERR_DUPLICATE_SERVICE: 'Update Error: Duplicate Service Name.',
    ERR_DURATION: 'Duration is required.'
    
}